export enum ObjectModelDefaultActionType {
  Create = 101,
  Edit = 102,
  Delete = 103,
}

export const ObjectModelDefaultActionTypeName = {
  [ObjectModelDefaultActionType.Create]: 'Create',
  [ObjectModelDefaultActionType.Edit]: 'Edit',
  [ObjectModelDefaultActionType.Delete]: 'Delete',
};